module.exports = __webpack_public_path__ + "img/ico_remove.107c4ab4.svg";